import { render, staticRenderFns } from "./default.vue?vue&type=template&id=01569a8a&scoped=true"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"
import style0 from "./default.vue?vue&type=style&index=0&id=01569a8a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01569a8a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Navigation: require('/builds/sR3RmDikN/0/gwt/sites/supersus/components/navigation/index.vue').default,InsideBanner: require('/builds/sR3RmDikN/0/gwt/sites/supersus/components/inside/banner.vue').default,Footer: require('/builds/sR3RmDikN/0/gwt/sites/supersus/components/footer/index.vue').default,Float: require('/builds/sR3RmDikN/0/gwt/sites/supersus/components/float/float.js').default,Player: require('/builds/sR3RmDikN/0/gwt/sites/supersus/components/player/player.vue').default})
